import { FC } from "react";
import EsInvesticijos from "@/components/BlankPages/EsInvesticijos";
import Container from "@/components/Container";

// import useMediaQuery from "@/custom_hooks/mediaQuery";
// import cx from 'classnames';

const EsInvestment: FC = () => {
  return (
    <div className="flex flex-col bg-white px-4">
      <Container>
        <EsInvesticijos />
      </Container>
    </div>
  );
};
export default EsInvestment;
